import React, { Fragment } from "react";
import { connect } from "react-redux";

const GiftSubscriptionResultItem = ({
  mentor: { _id, avatar, channelid, firstname, lastname, jobtitle, location },
  setMentor,
}) => {
  return (
    <Fragment>
      <div
        className="hero-search-results"
        onClick={() =>
          setMentor({
            _id,
            avatar,
            channelid,
            firstname,
            lastname,
            jobtitle,
            location,
          })
        }
      >
        <div className="profile-drop-container">
          <div className="onlive-avi-container">
            <div className="avi-color-border-mini red">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                className="mini-avi"
                alt="miniavi"
              />
            </div>
          </div>
          <ul className="user-online-items">
            <li className="user-online-item-mini">
              <span className="red name-font-mini bold">
                {firstname} {lastname}
              </span>
            </li>
            <li className="user-online-item-mini">
              <span className="red name-font-mini bold">{channelid}</span>
            </li>
            <li className="user-online-item-mini">{jobtitle}</li>
            <li className="user-online-item-mini">
              {location.city}, {location.state}
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(GiftSubscriptionResultItem);
